// iter259 — SINGLE shared barcode normalizer used by every scan input path
// (camera decode, manual keyboard entry, Bluetooth/USB keyboard-wedge) so all
// three resolve to the exact same canonical registry value.
//
// Scanners and 1D decoders frequently append/prepend characters that render
// invisibly but break an exact string match against the registry:
//   • AIM symbology identifier prefixes: "]C1", "]C0", "]A0", "]Q1", "]d2" …
//   • Control characters: NUL (\x00), GS/FNC1 (\x1d), CR/LF/TAB, DEL, C1 range
//   • Zero-width / BOM characters: \u200B–\u200D, \uFEFF
//   • Leading / trailing whitespace
//
// We ONLY strip non-data noise. We NEVER alter, pad, truncate, or fuzzy-match
// the actual digits/value.

const AIM_PREFIX = /^\][A-Za-z][0-9]/;             // e.g. ]C1  ]C0  ]A0  ]Q1  ]d2
// C0 controls (\x00-\x1F incl. GS \x1D + CR/LF/TAB), DEL (\x7F), C1 (\x80-\x9F),
// zero-width space/joiners (\u200B-\u200D), and BOM (\uFEFF).
const NOISE_CHARS = /[\u0000-\u001F\u007F-\u009F\u200B-\u200D\uFEFF]/g;

export function normalizeBarcode(raw) {
  let s = raw == null ? '' : String(raw);
  s = s.replace(AIM_PREFIX, '');   // drop AIM symbology identifier (metadata, not data)
  s = s.replace(NOISE_CHARS, '');  // drop control + zero-width noise anywhere in the string
  s = s.trim();                    // drop leading/trailing whitespace (incl. unicode)
  return s;
}

// Diagnostic helper — describes the raw vs normalized value so we can log/report
// exactly what a scanner emitted (answers "what is the camera actually passing?").
export function describeScan(raw) {
  const rawStr = raw == null ? '' : String(raw);
  const normalized = normalizeBarcode(rawStr);
  const codes = Array.from(rawStr).map((ch) => ch.codePointAt(0));
  return {
    raw: rawStr,
    rawJson: JSON.stringify(rawStr),          // shows \u001d, \n, etc. explicitly
    rawCharCodes: codes,                       // e.g. [49,48,...,29]
    rawLength: rawStr.length,
    normalized,
    normalizedLength: normalized.length,
    changed: rawStr !== normalized,
  };
}
